import {
  Typography,
  Grid,
  Divider,
  TextField,
  IconButton
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { Password } from 'primereact/password';
import { useLocation, useNavigate } from 'react-router-dom';
import VerificationInput from 'react-verification-input';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  ContainerFormProfile,
  ErrorText,
  ContainerForm
} from '../CreateUser/createUserStyles';
import Strings from '../../../i18n';
import { colors } from '../../../constants/colors';
import { ContainerImage } from '../../../views/registration/registrationViewStyles';
import {
  useLoginWithOTPMutation,
  useLoginWithPasswordMutation,
  useStartLoginWithOTPMutation
} from '../../../services/auth/authServices';
import {
  loginWithOtpValidator,
  loginWithPasswordValidator
} from '../../../utils/validators';
import {
  selectCurrentUser,
  setCredentials,
  setRoleLoggedUser,
  setUserInfo
} from '../../../store/slices/login/login';
import { useGetLoggedUserSystemRolePermissionsMutation } from '../../../services/systemPermissions/systemPermissionsService';
import { useGetUserInfoMutation } from '../../../services/users/usersService';
import './loginWithPasswordStyle.css';

const logoImg = require('../../../assets/logo.png');

export const LoginWithPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const emailFromUrl = queryParams.get('email');
  const { loginWithRedirect } = useAuth0();
  const currentUser = useSelector(selectCurrentUser);
  const [passwordLess, setPasswordLess] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<string>('');
  const [
    loginWithPassword,
    { isSuccess: isSuccessLogin, isLoading, data, error, isError }
  ] = useLoginWithPasswordMutation();

  const [
    getRoleByToken,
    { isLoading: isLoadingGetRole, data: dataRole, isSuccess: isSuccessGetRole }
  ] = useGetLoggedUserSystemRolePermissionsMutation();

  const [
    sendOTPCode,
    {
      isSuccess: isSuccessSendingCode,
      error: errorSendOTPCode,
      isError: isErrorSendOptCode
    }
  ] = useStartLoginWithOTPMutation();

  useEffect(() => {
    if (isSuccessSendingCode) {
      toast.success('Please check junk email folder.');
      setPasswordLess((tmpPasswordLess) => !tmpPasswordLess);
    }
  }, [isSuccessSendingCode]);

  const [
    loginWithOTP,
    {
      isSuccess: isSuccessLoginWithOTP,
      data: dataLoginWithOTP,
      error: errorLoginOTPCode,
      isError: isErrorLoginOptCode
    }
  ] = useLoginWithOTPMutation();

  useEffect(() => {
    if (isErrorSendOptCode && errorSendOTPCode) {
      if ('data' in errorSendOTPCode && errorSendOTPCode.data) {
        const errorData = errorSendOTPCode.data as { message?: string };
        toast.error(errorData.message || 'Error sending Code');
      } else {
        toast.error('Error sending Code');
      }
    }
  }, [isErrorSendOptCode, errorSendOTPCode]);

  useEffect(() => {
    if (isErrorLoginOptCode && errorLoginOTPCode) {
      if ('data' in errorLoginOTPCode && errorLoginOTPCode.data) {
        const errorData = errorLoginOTPCode.data as { message?: string };
        toast.error(errorData.message);
      } else {
        toast.error('Try again later.');
      }
    }
  }, [isErrorLoginOptCode, errorLoginOTPCode]);

  const [
    getInfo,
    {
      isLoading: isLoadingGetInfo,
      data: dataGetInfo,
      isSuccess: isSuccessGetInfo,
      isError: isErrorGetInfo
    }
  ] = useGetUserInfoMutation();

  useEffect(() => {
    if (isSuccessLoginWithOTP && dataLoginWithOTP) {
      toast.success('success');

      localStorage.setItem('authToken', dataLoginWithOTP.token);
      localStorage.setItem('refreshToken', dataLoginWithOTP.refreshToken);

      dispatch(
        setCredentials({
          user: '',
          email: dataLoginWithOTP.username,
          token: dataLoginWithOTP.token,
          picture: '',
          roleInfo: '',
          userInfo: null,
          refreshToken: dataLoginWithOTP.refreshToken,
          authWithApi: true,
          userId: dataLoginWithOTP.id
        })
      );
      getRoleByToken('');
      getInfo();
    }
  }, [isSuccessLoginWithOTP && dataLoginWithOTP]);

  const sendInfo = (payload: any) => {
    loginWithPassword(payload);
  };

  const redirectToCreate = () => {
    navigate('/create-user');
  };

  const redirectToPasswordless = () => {
    loginWithRedirect();
  };

  const redirectToForgotPassword = () => {
    navigate('/reset-password');
  };

  useEffect(() => {
    if (isError && error) {
      if ('message' in error) {
        toast.error(error.message);
      } else if ('data' in error) {
        toast.error('Error occurred during login');
      }
    }
  }, [isSuccessLogin, isError, error]);

  useEffect(() => {
    if (isSuccessLogin && data) {
      toast.success('success');

      localStorage.setItem('authToken', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);

      dispatch(
        setCredentials({
          user: '',
          email: data.username,
          token: data.token,
          picture: '',
          roleInfo: '',
          userInfo: null,
          refreshToken: data.refreshToken,
          authWithApi: true,
          userId: data.id
        })
      );
      getRoleByToken('');
      getInfo();
    }
  }, [isSuccessLogin]);

  useEffect(() => {
    if (dataGetInfo && isSuccessGetRole && isSuccessGetInfo) {
      const { firstName, lastName, phoneNumber, lastLogin } = dataGetInfo;
      dispatch(
        setRoleLoggedUser({
          roleInfo: dataRole
        })
      );
      dispatch(
        setUserInfo({
          userInfo: { firstName, lastName, phoneNumber, lastLogin }
        })
      );
      if (dataGetInfo.userId > 0) {
        navigate('/');
      } else {
        toast.error('error 1 ');
      }
    }
    if (!isSuccessGetInfo && isErrorGetInfo) {
      toast.error('error 2');
    }
  }, [
    isLoadingGetInfo,
    isSuccessGetRole,
    data,
    isSuccessGetInfo,
    isErrorGetInfo
  ]);
  return (
    <ContainerImage>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="left"
        alignItems="center"
      >
        <Grid item xs={0.5} md={2} />
        <Grid item xs={11} md={6} lg={3.5}>
          <ContainerForm container padding={3} justifyContent="center">
            <Grid item xs={11}>
              <Typography align="center" marginY={2} variant="h5">
                <img src={logoImg} alt="Haven Logo" width={200} />
              </Typography>
              <Typography
                align="center"
                marginY={3}
                variant="h6"
                fontWeight="bold"
                color={colors.strongGray}
                paddingTop={2}
              >
                {Strings.login.logIn}
              </Typography>
            </Grid>
            <ContainerFormProfile item xs={10} md={8} lg={12}>
              <Formik
                enableReinitialize
                validationSchema={
                  passwordLess
                    ? loginWithOtpValidator
                    : loginWithPasswordValidator
                }
                initialValues={{
                  userName: emailFromUrl || '',
                  password: '',
                  otp: ''
                }}
                onSubmit={(values) => {
                  if (passwordLess) {
                    loginWithOTP({
                      username: values.userName,
                      password: values.otp
                    });
                  } else {
                    sendInfo({
                      userName: values.userName,
                      password: values.password
                    });
                  }
                }}
              >
                {({
                  handleChange,
                  handleSubmit,
                  values,
                  isValid,
                  setFieldTouched,
                  errors,
                  touched,
                  setFieldValue
                }) => (
                  <Grid
                    direction="row"
                    container
                    spacing={2}
                    justifyContent="center"
                  >
                    <Grid item xs={12} md={10}>
                      <TextField
                        value={values.userName}
                        id="userName"
                        label={Strings.userProfile.emailLabel}
                        onBlur={() => setFieldTouched('userName')}
                        onChange={handleChange('userName')}
                        name="userName"
                        fullWidth
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                      {touched.userName && errors.userName && (
                        <ErrorText>{errors.userName}</ErrorText>
                      )}
                      {emailError && <ErrorText>{emailError}</ErrorText>}
                    </Grid>
                    <Grid item xs={12} md={10} className="password-container">
                      <span className="password-label">
                        {Strings.userProfile.passwordLabel}
                      </span>
                      {passwordLess ? (
                        <div className="verification-input-wrapper">
                          <VerificationInput
                            classNames={{
                              container: 'container',
                              character: 'character',
                              characterInactive: 'character--inactive',
                              characterSelected: 'character--selected',
                              characterFilled: 'character--filled'
                            }}
                            value={values.otp}
                            length={4}
                            onChange={handleChange('otp')}
                            autoFocus
                            inputProps={{
                              autoComplete: 'new-password',
                              autoCorrect: 'off',
                              autoCapitalize: 'none',
                              spellCheck: 'false'
                            }}
                          />
                          <IconButton
                            aria-label="clear verification code"
                            className="clear-button"
                            onClick={() => {
                              setFieldValue('password', '');
                            }}
                            size="small"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                          {touched.otp && errors.otp && (
                            <ErrorText>{errors.otp}</ErrorText>
                          )}
                        </div>
                      ) : (
                        <>
                          <Password
                            value={values.password}
                            id="password"
                            onBlur={() => setFieldTouched('password')}
                            onChange={handleChange('password')}
                            name="password"
                            toggleMask
                            feedback={false}
                            type="password"
                            className="w-100"
                          />
                          {touched.password && errors.password && (
                            <ErrorText>{errors.password}</ErrorText>
                          )}
                        </>
                      )}
                    </Grid>
                    <Grid item xs={10} md={8} marginTop={1}>
                      <LoadingButton
                        color="info"
                        className="w-100"
                        disabled={!isValid}
                        onClick={() => handleSubmit()}
                        variant="contained"
                        size="large"
                        loading={isLoading}
                      >
                        {Strings.login.logIn}
                      </LoadingButton>
                    </Grid>
                    <Grid item xs={10} md={12}>
                      <button
                        type="button"
                        className="btn-action"
                        onClick={redirectToForgotPassword}
                      >
                        {Strings.login.forgotPasswordAsk}
                      </button>
                    </Grid>
                    {!passwordLess && (
                      <Grid item xs={10} md={12} marginTop={1}>
                        <button
                          type="button"
                          className="btn-action"
                          onClick={() => {
                            if (!passwordLess && !values.userName) {
                              setEmailError(Strings.formCommons.fieldRequired);
                              return;
                            }
                            if (!passwordLess) {
                              sendOTPCode({
                                userInfo: values.userName,
                                targetType: 'Email'
                              });
                            }
                            if (passwordLess) {
                              setPasswordLess(false);
                            }
                          }}
                        >
                          {Strings.login.loginWith}{' '}
                          <span>
                            {passwordLess
                              ? Strings.login.password
                              : Strings.login.passwordless}
                            .
                          </span>
                        </button>
                      </Grid>
                    )}
                    <Grid item xs={10} md={12}>
                      <button
                        type="button"
                        className="btn-action"
                        onClick={redirectToCreate}
                      >
                        {Strings.login.createAccount}
                      </button>
                    </Grid>
                  </Grid>
                )}
              </Formik>
            </ContainerFormProfile>
          </ContainerForm>
        </Grid>
        <ToastContainer
          newestOnTop
          position="bottom-center"
          draggable
          theme="colored"
          autoClose={4000}
        />
        <Divider variant="fullWidth" />
      </Grid>
    </ContainerImage>
  );
};
